import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function Icon(props) {
  const {iconStyle, icon, className, ...rest} = props;
  return <span className={classNames('icon', iconStyle, `fa-${icon}`, className)} {...rest} />;
}

Icon.defaultProps = {
  iconStyle: 'fas',
};

Icon.propTypes = {
  /** The style of icon. Should be a FontAwesome style 'far', 'fas', etc. */
  iconStyle: PropTypes.string,
  /** The name of the icon to display. */
  icon: PropTypes.string.isRequired,
  /** An optional class name to add to the HTML element. */
  className: PropTypes.string,
};
